export class OptLockDTO {
    optLock: Date;
}